module.exports = __webpack_public_path__ + "img/configurator-promo-shadow-1.0a010de2.png";